export default __webpack_public_path__ + "img/rich_1-4d092dd4.png";